import "ie-array-find-polyfill"
import React from "react"
import { BreakpointsProvider } from "./context/breakpointsContext"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import "react-toastify/dist/ReactToastify.css"
import { breakpoints } from "./breakpoints"
import AppSwitch from "./containers/AppSwitch"
import { LangProvider } from "./context/lang"
import { ImpersonateProvider } from "./context/impersonate"
import { configureAmplify } from "./auth"

configureAmplify()

export default function App() {
    return (
        <ImpersonateProvider>
            <BreakpointsProvider breakpoints={breakpoints}>
                <LangProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route
                                path="/*"
                                element={<AppSwitch lang={""} />}
                            />
                        </Routes>
                    </BrowserRouter>
                </LangProvider>
            </BreakpointsProvider>
        </ImpersonateProvider>
    )
}
